export class GHGVerificationUnsavedChangesDialog {

    model: { onSave: () => Promise<void>, onDiscard: () => Promise<void>, onCancel: () => Promise<void> };

    activate(model: { onSave: () => Promise<void>, onDiscard: () => Promise<void>, onCancel: () => Promise<void> }) {
        this.model = model;
    }

    saveChanges() {
        return new Promise<void>((resolve, reject) => {
            const promise = this.model.onSave();
            if (promise instanceof Promise) {
                promise.then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
            } else {
                resolve();
            }
        });
    }

    discardChanges() {
        return new Promise<void>((resolve, reject) => {
            const promise = this.model.onDiscard();
            if (promise instanceof Promise) {
                promise.then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
            } else {
                resolve();
            }
        });
    }

    cancel() {
        return new Promise<void>((resolve, reject) => {
            const promise = this.model.onCancel();
            if (promise instanceof Promise) {
                promise.then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
            } else {
                resolve();
            }
        });
    }
}